import type { InvoiceState, InvoiceType } from '@mynt/backoffice-api-spec/invoice'
import { InvoiceApiFactory } from '@mynt/backoffice-api-spec/invoice'
import Axios from 'api/axios'
import config from 'config'

const invoiceApi = InvoiceApiFactory(undefined, config.boBaseUrl, Axios)

export type InvoiceFilters = {
  customerId?: string
  type?: InvoiceType[]
  state?: InvoiceState[]
  invoiceDateFrom?: string
  invoiceDateTo?: string
  settlementDateFrom?: string
  settlementDateTo?: string
  receiverName?: string
  invoiceNo?: string
  currency?: string[]
  dueDateFrom?: string
  dueDateTo?: string
  grossTotalMin?: number
  grossTotalMax?: number
}

export type InvoicePagination = {
  page: number
  pageSize: number
}

export const getInvoicesPaginated = (filters: InvoiceFilters, pagination: InvoicePagination) =>
  invoiceApi
    .listInvoicesPaginated(
      filters.customerId,
      filters.type,
      filters.state,
      filters.invoiceDateFrom,
      filters.invoiceDateTo,
      filters.settlementDateFrom,
      filters.settlementDateTo,
      filters.receiverName,
      filters.invoiceNo,
      filters.currency,
      filters.dueDateFrom,
      filters.dueDateTo,
      filters.grossTotalMin,
      filters.grossTotalMax,
      pagination.page,
      pagination.pageSize,
    )
    .then(({ data }) => data)
